module.exports = __webpack_public_path__ + "media/entities/1131-85983806.png";